import { c as _c } from "react/compiler-runtime";
// «Таблица размеров» карточки товара — как шторка приложения
// (ProductSizeTableBottomSheet, кадр 3664:70380): колонки RUS и обхваты груди,
// талии и бёдер в см; строка — радиокнопка размера, нет в наличии — бледная и
// не выбирается. Выбор строки выбирает тот же размер на карточке. Справа —
// свои мерки продавца (длина рукава, спинки…; 19.10.2026), обхваты — только
// если они есть хоть у одного размера.
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@osmix/ui/dialog";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { SizeTableRow } from "@/lib/product-size";
import { cn } from "@/lib/utils";
export function SizeTableDialog(t0) {
  const $ = _c(73);
  const {
    open,
    onOpenChange,
    rows,
    measureColumns: t1,
    selected,
    onSelect
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const measureColumns = t2;
  const {
    t
  } = useTranslation();
  let t3;
  if ($[2] !== rows) {
    t3 = rows.some(_temp);
    $[2] = rows;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const body = t3;
  let t4;
  if ($[4] !== measureColumns || $[5] !== rows) {
    let t5;
    if ($[7] !== rows) {
      t5 = (_, index) => rows.some(row_0 => row_0.extra[index]);
      $[7] = rows;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = measureColumns.map(t5);
    $[4] = measureColumns;
    $[5] = rows;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const extraShown = t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      width: "min(520px, calc(100vw - 32px))"
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("product.sizeTableTitle");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <DialogTitle className="pt-1 text-[20px] leading-[23px] font-semibold tracking-[-0.31px] text-[#161616]">{t6}</DialogTitle>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("common.close", {
      defaultValue: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
    });
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== onOpenChange) {
    t9 = () => onOpenChange(false);
    $[16] = onOpenChange;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <X className="size-5" />;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t8 || $[20] !== t9) {
    t11 = <button type="button" aria-label={t8} onClick={t9} className="grid size-8 shrink-0 place-items-center rounded-full text-[#161616] transition-colors hover:bg-[#F3F3F4]">{t10}</button>;
    $[19] = t8;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t7) {
    t12 = <div className="mb-3 flex items-start justify-between gap-3">{t7}{t11}</div>;
    $[22] = t11;
    $[23] = t7;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t) {
    t13 = t("product.sizeTableHint");
    $[25] = t;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13) {
    t14 = <DialogDescription className="mb-3 text-[14px] leading-[18px] text-black/50">{t13}</DialogDescription>;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t) {
    t15 = t("product.sizeTableColSize");
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t15) {
    t16 = <th scope="col" className="px-2 py-2.5 text-left text-[13px] leading-[17px] font-semibold text-[#161616]">{t15}</th>;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== body || $[34] !== t) {
    t17 = body && <><th scope="col" className="px-2 py-2.5 text-left text-[13px] leading-[17px] font-semibold text-[#161616]">{t("product.sizeTableColChest")}</th><th scope="col" className="px-2 py-2.5 text-left text-[13px] leading-[17px] font-semibold text-[#161616]">{t("product.sizeTableColWaist")}</th><th scope="col" className="px-2 py-2.5 text-left text-[13px] leading-[17px] font-semibold text-[#161616]">{t("product.sizeTableColHips")}</th></>;
    $[33] = body;
    $[34] = t;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== extraShown || $[37] !== measureColumns) {
    let t19;
    if ($[39] !== extraShown) {
      t19 = (label, index_0) => extraShown[index_0] ? <th key={`${label}-${index_0}`} scope="col" className="px-2 py-2.5 text-left text-[13px] leading-[17px] font-semibold text-[#161616]" data-testid="size-table-own-measure">{label}</th> : null;
      $[39] = extraShown;
      $[40] = t19;
    } else {
      t19 = $[40];
    }
    t18 = measureColumns.map(t19);
    $[36] = extraShown;
    $[37] = measureColumns;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[41] !== t16 || $[42] !== t17 || $[43] !== t18) {
    t19 = <thead><tr className="border-b border-[#EFEFEF]">{t16}{t17}{t18}</tr></thead>;
    $[41] = t16;
    $[42] = t17;
    $[43] = t18;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== body || $[46] !== extraShown || $[47] !== measureColumns || $[48] !== onSelect || $[49] !== rows || $[50] !== selected || $[51] !== t) {
    let t21;
    if ($[53] !== body || $[54] !== extraShown || $[55] !== measureColumns || $[56] !== onSelect || $[57] !== selected || $[58] !== t) {
      t21 = row_1 => {
        const on = row_1.size === selected;
        const off = !row_1.available;
        const cell = cn("px-2 py-2.5 text-[14px] leading-[18px]", off ? "text-black/40" : "text-[#161616]");
        return <tr key={row_1.size} aria-selected={on} title={off ? t("product.sizeTableOut") : undefined} onClick={() => !off && onSelect(row_1.size)} className={cn("border-b border-[#EFEFEF] last:border-0", off ? "cursor-not-allowed" : "cursor-pointer hover:bg-[#F8F8F8]", on && "bg-[#F8F8F8]")}><td className={cell}><label className={cn("flex items-center gap-2", off ? "cursor-not-allowed" : "cursor-pointer")}><input type="radio" name="size-table" checked={on} disabled={off} onChange={() => onSelect(row_1.size)} className="size-4 accent-[#1F1F1F]" /><span className="font-semibold">{row_1.label}</span>{row_1.secondaryLabel ? <span className="text-black/40">{row_1.secondaryLabel}</span> : null}</label></td>{body && <><td className={cell}>{row_1.chest || "\u2014"}</td><td className={cell}>{row_1.waist || "\u2014"}</td><td className={cell}>{row_1.hips || "\u2014"}</td></>}{measureColumns.map((label_0, index_1) => extraShown[index_1] ? <td key={`${label_0}-${index_1}`} className={cell}>{row_1.extra[index_1] || "\u2014"}</td> : null)}</tr>;
      };
      $[53] = body;
      $[54] = extraShown;
      $[55] = measureColumns;
      $[56] = onSelect;
      $[57] = selected;
      $[58] = t;
      $[59] = t21;
    } else {
      t21 = $[59];
    }
    t20 = rows.map(t21);
    $[45] = body;
    $[46] = extraShown;
    $[47] = measureColumns;
    $[48] = onSelect;
    $[49] = rows;
    $[50] = selected;
    $[51] = t;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  let t21;
  if ($[60] !== t20) {
    t21 = <tbody>{t20}</tbody>;
    $[60] = t20;
    $[61] = t21;
  } else {
    t21 = $[61];
  }
  let t22;
  if ($[62] !== t19 || $[63] !== t21) {
    t22 = <div className="overflow-x-auto"><table className="w-full min-w-[320px] border-collapse">{t19}{t21}</table></div>;
    $[62] = t19;
    $[63] = t21;
    $[64] = t22;
  } else {
    t22 = $[64];
  }
  let t23;
  if ($[65] !== t12 || $[66] !== t14 || $[67] !== t22) {
    t23 = <DialogContent showCloseButton={false} overlayClassName="bg-black/20 backdrop-blur-[2px]" className="gap-0 rounded-[20px] border-0 bg-white p-4 shadow-none sm:max-w-none" style={t5} data-testid="size-table-dialog">{t12}{t14}{t22}</DialogContent>;
    $[65] = t12;
    $[66] = t14;
    $[67] = t22;
    $[68] = t23;
  } else {
    t23 = $[68];
  }
  let t24;
  if ($[69] !== onOpenChange || $[70] !== open || $[71] !== t23) {
    t24 = <Dialog open={open} onOpenChange={onOpenChange}>{t23}</Dialog>;
    $[69] = onOpenChange;
    $[70] = open;
    $[71] = t23;
    $[72] = t24;
  } else {
    t24 = $[72];
  }
  return t24;
}
function _temp(row) {
  return row.chest || row.waist || row.hips;
}